export type InstitutionKey = keyof typeof institutionsMapping;
export type InstitutionName = (typeof institutionsMapping)[InstitutionKey];

const institutionsMapping = {
  SN: "Sénat",
  AN: "Assemblée nationale",
  GV: "Gouvernement",
};
const reverseInstitutionMappings: Record<InstitutionName, InstitutionKey> = {};
for (const [key, value] of Object.entries(institutionsMapping)) {
  reverseInstitutionMappings[value as InstitutionName] = key as InstitutionKey;
}

function getInstitutionsNames(institutionKey: InstitutionKey) {
  return institutionsMapping[institutionKey] || institutionKey;
}

function reverseInstitutionsNames(institutionName: InstitutionName) {
  return reverseInstitutionMappings[institutionName] || institutionName;
}

export { getInstitutionsNames, reverseInstitutionsNames };
